import { ARRAY_OF_CLIENTS_01 } from '../../../mocks/clients.data';
import {
    ARRAY_OF_INSTRUMENTS_01,
    ARRAY_OF_INSTRUMENTS_02,
    ARRAY_OF_INSTRUMENTS_03,
} from '../../../mocks/instruments.data';
import { delay, map, shareReplay, takeUntil } from 'rxjs/operators';
import { IFirmsAndInstrumentsAdapterService } from './firms-and-instruments-adapter.interface';
import {
    IFirmsAndInstrumentsMessageResponse,
    ISessionDisposable, IStateManagerService,
} from '../../../interfaces';
import { inject, injectable } from 'inversify';
import { ISessionLifecycle, SESSION_LIFECYCLE_SERVICE } from '../../session-lifecycle';
import { Observable } from 'rxjs';
import { SESSION_STATE_SERVICE } from '../../session-state';

const MAX_RESPONSE_DELAY = 600;

@injectable()
export class FirmsAndInstrumentsAdapterServiceMock implements IFirmsAndInstrumentsAdapterService, ISessionDisposable {
    @inject(SESSION_STATE_SERVICE) private readonly sessionStateSrv: IStateManagerService;
    @inject(SESSION_LIFECYCLE_SERVICE) private readonly sessionLifeCycle: ISessionLifecycle;

    asObservable(): Observable<IFirmsAndInstrumentsMessageResponse> {
        return this.sessionStateSrv.stateObservable('selectedClientId')
            .pipe(
                takeUntil(this.sessionLifeCycle.destroyObservable()),
                map(this.getFirmsAndInstruments),
                shareReplay(1),
                delay(MAX_RESPONSE_DELAY * Math.random()),
            );
    }

    private getFirmsAndInstruments(
        attachedClientId: number,
    ): IFirmsAndInstrumentsMessageResponse {
        const instrumentsMap = {
            1: ARRAY_OF_INSTRUMENTS_01,
            2: ARRAY_OF_INSTRUMENTS_02,
            3: ARRAY_OF_INSTRUMENTS_03,
        };
        return {
            clients: ARRAY_OF_CLIENTS_01,
            instrumentsMap,
            attachedClientId: attachedClientId,
        };
    }

    stop: () => void;
}
